import { sellerHeader } from "../animation/RoutesAnimations";
import { Outlet } from "react-router-dom";
import { motion } from "framer-motion";
import UserPanelSidebar from "../components/drawer/UserPanelSidebar";
import HeaderLandignUserPanel from "../components/header/HeaderLandignUserPanel";
import { Helmet } from "react-helmet";

const UserDashboardLayout = ({ enteredUser, setEnteredUser }: any) => {
  return (
    <motion.div
      variants={sellerHeader}
      initial="initial"
      animate="final"
      className=" min-h-screen relative w-full overflow-x-hidden bg-gray-100"
    >
      <Helmet>
        <title>پنل کاربر وامسی</title>
        <meta name="description" content="پنل کاربر وامسی" />
        <link rel="canonical" href="https://vam30.com/fa/user-panel" />
      </Helmet>
      <div className="bg-white">
        <HeaderLandignUserPanel
          enteredUser={enteredUser}
          setEnteredUser={setEnteredUser}
        />
      </div>

      <div className="max-w-[1600px] mx-auto flex item-center justify-center ">
        <div className="flex bg-gray-100 item-center justify-center lg:basis-1/4 basis-0">
          <UserPanelSidebar
            enteredUser={enteredUser}
            setEnteredUser={setEnteredUser}
          />
        </div>
        <div className="sm:basis-3/4 w-full">
          <Outlet />
        </div>
      </div>
    </motion.div>
  );
};

export default UserDashboardLayout;
